var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_1362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 12.1733C8.32651 12.1733 8.59116 11.9087 8.59116 11.5822C8.59116 11.2557 8.32651 10.9911 8.00005 10.9911C7.67358 10.9911 7.40894 11.2557 7.40894 11.5822C7.40894 11.9087 7.67358 12.1733 8.00005 12.1733Z",
    fill: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00011 10.0489C7.88223 10.0489 7.76919 10.0021 7.68584 9.91871C7.60249 9.83536 7.55566 9.72231 7.55566 9.60444V4.2711C7.55566 4.15323 7.60249 4.04018 7.68584 3.95684C7.76919 3.87349 7.88223 3.82666 8.00011 3.82666C8.11798 3.82666 8.23103 3.87349 8.31438 3.95684C8.39773 4.04018 8.44455 4.15323 8.44455 4.2711V9.60444C8.44455 9.72231 8.39773 9.83536 8.31438 9.91871C8.23103 10.0021 8.11798 10.0489 8.00011 10.0489Z",
    fill: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 15.1111C6.59359 15.1111 5.21872 14.6941 4.04931 13.9127C2.87989 13.1313 1.96844 12.0207 1.43022 10.7213C0.891997 9.42195 0.751173 7.99214 1.02556 6.61272C1.29994 5.2333 1.97721 3.96622 2.97172 2.97172C3.96622 1.97721 5.2333 1.29994 6.61272 1.02556C7.99214 0.751173 9.42195 0.891997 10.7213 1.43022C12.0207 1.96844 13.1313 2.87989 13.9127 4.04931C14.6941 5.21872 15.1111 6.59359 15.1111 8.00003C15.1111 9.88601 14.3619 11.6948 13.0283 13.0283C11.6948 14.3619 9.88601 15.1111 8.00003 15.1111ZM8.00003 1.77781C6.76939 1.77781 5.56639 2.14274 4.54315 2.82644C3.51991 3.51015 2.72239 4.48193 2.25145 5.61889C1.7805 6.75585 1.65728 8.00693 1.89737 9.21393C2.13745 10.4209 2.73006 11.5296 3.60025 12.3998C4.47045 13.27 5.57914 13.8626 6.78614 14.1027C7.99313 14.3428 9.24421 14.2196 10.3812 13.7486C11.5181 13.2777 12.4899 12.4802 13.1736 11.4569C13.8573 10.4337 14.2223 9.23067 14.2223 8.00003C14.2223 6.34979 13.5667 4.76715 12.3998 3.60025C11.2329 2.43336 9.65027 1.77781 8.00003 1.77781Z",
    fill: "#FF5A5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_1362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.042cea4ca1eafa7a8679c5d835c0608c.svg";
export { ForwardRef as ReactComponent };